module.exports = __webpack_public_path__ + "img/2.abc3ef34.png";